import React, { useMemo } from 'react';
import { getAllModelFields, listToHashMapFromKey } from '../utils';
import { LongNameWrapper } from './SchemaConfigValuesUI';
import LongNameWithTooltip from '../LongNameWithTooltip';
import { ConfigurationLabel } from '../DataModelerCommonUI';
import { DataModelerConfigLabelWithInfo } from '../DataModelerShared';
import { dataModelLabelInfoTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';
import styled from 'styled-components';
import { useDataModelerContext } from '../../DataModelerContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

const SchemaSubjectsList = () => {
  const { draftEdits, schemaObj } = useDataModelerContext();

  const allExistingFieldsByKey = useMemo(
    () => listToHashMapFromKey(getAllModelFields(schemaObj), 'key'),
    [schemaObj],
  );

  const existingSubjects = useMemo(() => {
    return (
      schemaObj?.subjects?.map((subj) => {
        return {
          subjectKey: subj.subjectKey,
          name: subj.name,
          fieldName: allExistingFieldsByKey[subj.fieldKey]?.name,
          isNew: false,
        };
      }) ?? []
    );
  }, [allExistingFieldsByKey, schemaObj?.subjects]);

  const newSubjects = useMemo(() => {
    const draftAddInputsByKey = listToHashMapFromKey(
      draftEdits?.draftFieldsData?.flatMap((draftField) =>
        draftField.addInput ? [draftField.addInput] : [],
      ) ?? [],
      'key',
    );
    return (
      draftEdits?.addedSubjects?.map((subj) => {
        return {
          subjectKey: subj.subjectKey,
          name: subj.input.subjectName,
          fieldName:
            draftAddInputsByKey[subj.input.fieldKey]?.name ??
            allExistingFieldsByKey[subj.input.fieldKey]?.name,
          isNew: true,
        };
      }) ?? []
    );
  }, [
    allExistingFieldsByKey,
    draftEdits?.addedSubjects,
    draftEdits?.draftFieldsData,
  ]);
  const allSubjects = useMemo(
    () => [...existingSubjects, ...newSubjects],
    [existingSubjects, newSubjects],
  );

  return (
    <Container>
      <DataModelerConfigLabelWithInfo
        labelText={'Subjects (Read Only)'}
        tooltipOption={dataModelLabelInfoTooltipOptions.subjectsReadOnly}
      />
      {allSubjects.length === 0 ? (
        <ConfigurationLabel>
          Subjects will be displayed here as read-only after they are configured
          in the data model
        </ConfigurationLabel>
      ) : (
        <>
          {allSubjects.map((subj) => (
            <ConfigurationLabel key={subj.subjectKey}>
              <LongNameWrapper>
                <LongNameWithTooltip name={subj.name} />
              </LongNameWrapper>
              <div>{subj.fieldName + (subj.isNew ? ' (NEW)' : '')}</div>
            </ConfigurationLabel>
          ))}
        </>
      )}
    </Container>
  );
};

export default SchemaSubjectsList;
